import spritesheet from 'assets/img/icons/spritesheet.svg';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './svg-icon.module.scss';

const SvgIcon = (props) => {
  const { className, name } = props;
  const xlink = `${spritesheet}#${name}`;

  return (
    <svg className={classnames(className, styles.icon, styles[name])}>
      <use xlinkHref={xlink} />
    </svg>
  );
};

SvgIcon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default SvgIcon;
